import { faChevronCircleLeft, faChevronLeft, faReply } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import Divider from '@material-ui/core/Divider';
import { Close } from '@material-ui/icons';
import { push } from "connected-react-router";
import * as React from 'react';
import { SpinnerComponent } from 'react-element-spinner';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { Button, Col, Label, Row } from "reactstrap";
import { Uploader } from '../../components/Uploader';
import { CallAxiosRequest } from '../../Helpers/axiosHelpers';
import { YoonitRequest, YoonitResponse } from '../../Interfaces/Interfaces';
import { Login, Logout } from '../../redux/actions/AuthActions';
import { IStore } from '../../redux/constants';
import { ParagraphEditor } from './ParagraphEditor';

const queryString = require('querystring');

const $ = require("jquery");
const moment = require('moment');

const mapStateToProps = (state: IStore) => ({
    userData: state.auth.UserData,
    lang: state.language.value,
    history: state.history,
    URL: state.auth.UserData.yoonitGetURL,
    theme: state.theme,
    location: state.router.location
});

const dispatchProps = { push, Login, Logout }
export interface EachTicketPageProps {
    lang: string;
    userData: any;
    push: any;
    URL: string;
    theme: any;
    t: any;
    location: any;
}

export interface EachTicketPageState {
    TicketBody: string;
    isLoading: boolean;
    openPreview: boolean;
    TicketID: string;
    Id: number;
    RequesterId: number;
    TicketSubject: string;
    CreationDate: string;
    CreationDateStr: string;
    PriorityID: number;
    CategoryID: number;
    TicketComments: any[];
    commentField: string;
    Attachments: any[];
    fileSrc: string;
    ispdf: boolean;
    attachIsUploading: number;
    Files: any[];
    TSOptions: any[];
    TSSelectedOption: any;
    Priority: string;
    Status: string;
    CreatedByName: string;
}
let headerParameters: any = {
    Token: ""
}
let statusOptions = [{ value: "new", label: "New" }, { value: "open", label: "Open" }, { value: "pending", label: "Pending" }, { value: "hold", label: "Hold" }, { value: "solved", label: "Solved" }, { value: "closed", label: "Closed" }];
class EachTicket extends React.Component<EachTicketPageProps, EachTicketPageState> {
    state = {
        TicketBody: '',
        isLoading: false,
        openPreview: false,
        TicketSubject: '',
        TicketID: '',
        Id: 0,
        RequesterId: 0,
        CreationDate: '',
        CreationDateStr: '',
        PriorityID: 0,
        CategoryID: 0,
        TicketComments: [],
        commentField: '',
        Attachments: [],
        fileSrc: '',
        ispdf: false,
        attachIsUploading: 0,
        Files: [],
        TSOptions: [],
        TSSelectedOption: null,
        Priority: "",
        Status: "",
        CreatedByName: ""
    }
    componentDidMount = () => {
        headerParameters.Token = this.props.userData.Token;
        let values = queryString.parse(this.props.location.search);
        let TicketID = values[Object.keys(values)[0]];
        this.setState({ TicketID }, this.getTicketDetails)
        this.ClearEditor();
        this.StatusOpt(statusOptions);
    }
    navigateToTickets = () => {
        this.props.push('/ServiceDesk');
    }
    Editor = React.createRef<ParagraphEditor>();
    SetReplyContent = (key: number, value: string) => {
        this.setState({ commentField: value })
    }
    StatusOpt = (statusOptions: any) => {
        var _statusOptions = [];
        for (var k = 0; k < statusOptions.length; k++) {
            _statusOptions.push({ value: statusOptions[k].value, label: statusOptions[k].label });
        }
        this.setState({ TSOptions: _statusOptions, TSSelectedOption: _statusOptions[0] });
    }
    getTicketDetails = () => {
        let ActionParams: YoonitRequest<any> = {
            ObjData: this.state.TicketID
        };
        this.setState({ isLoading: true });
        CallAxiosRequest<YoonitRequest<any>, YoonitResponse<any>>(this.props.userData.TechAPIURL, 'Ticket/GetClientTicket',
            ActionParams,
            headerParameters,
            (result: YoonitResponse<any>) => {
                if (result.data.LiveRes) {
                    this.setState({
                        Id: result.data.LiveRes.Request.Id,
                        RequesterId: result.data.LiveRes.Request.RequesterId,
                        TicketSubject: result.data.LiveRes.Request.Subject,
                        Priority: result.data.LiveRes.Request.Priority,
                        TicketBody: result.data.LiveRes.Request.HtmlBody,
                        CreationDate: result.data.LiveRes.Request.CreationDate,
                        CreationDateStr: result.data.LiveRes.Request.CreatedAt,
                        TicketComments: result.data.LiveRes.Comments,
                        Attachments: result.data.LiveRes.Attachments,
                        Status: result.data.LiveRes.Request.Status
                    })

                }
                this.setState({ isLoading: false });
            },
            (e: any) => {
                this.setState({ isLoading: false });
            },
            (value: any) => String(value)
        );
    }
    ValidateInput = (value: any): boolean => {
        if (value !== null && value !== undefined && value !== "" && value !== 0)
            return true;
        return false;
    }
    ClearEditor = () => {
        if (this.Editor.current !== null)
            this.Editor.current.changeContent('');
    }
    openPreview = () => {
        this.setState({ openPreview: true })
    }
    closePreview = () => {
        this.setState({ openPreview: false })
    }
    uploadRef: any = React.createRef();
    cancelAddComment = () => {
        this.uploadRef.current.state.Files = [];
        this.SetReplyContent(0, '');
        this.ClearEditor();
        //remove attachments
    }
    addComment = () => {
        if (this.ValidateInput(this.state.commentField) && this.state.attachIsUploading === 0) {
            let ActionParams: YoonitRequest<any> = {
                ObjData: {
                    TicketID: this.state.TicketID,
                    Comment: this.state.commentField,
                    Attachments: this.state.Files,
                    ZID: this.props.userData.ZendeskID
                }
            };
            this.setState({ isLoading: true });
            CallAxiosRequest<YoonitRequest<any>, YoonitResponse<any>>(this.props.userData.TechAPIURL, 'Ticket/AddClientComment',
                ActionParams,
                headerParameters,
                (result: YoonitResponse<any>) => {
                    if (result.data.IntRes > 0) {
                        toastr.success('', this.props.t('Added'));
                        this.getTicketDetails();
                        this.uploadRef.current.state.Files = [];
                        this.SetReplyContent(0, '');
                    }
                    this.setState({
                        isLoading: false,
                        commentField: ''
                    }, this.ClearEditor);
                },
                (e: any) => {
                    this.setState({ isLoading: false });
                },
                (value: any) => String(value)
            );
        }
    }
    PreviewAttachment = (AttachmentData: string, AttachmentType: string) => {
        //  this.setState({ fileSrc: result.data.LiveRes, ispdf: AttachmentType === '.pdf' }, this.openPreview)

    }
    downloadAttachment = (Attachment: any) => {
        let ActionParams: YoonitRequest<any> = {
            ObjData: Attachment.AttachmentName
        };
        this.setState({ isLoading: true });
        CallAxiosRequest<YoonitRequest<any>, YoonitResponse<any>>(this.props.userData.TechAPIURL, 'Ticket/DownloadAttachment',
            ActionParams,
            headerParameters,
            (result: YoonitResponse<any>) => {
                if (result.data.LiveRes != null) {
                    let ext = Attachment.AttachmentType.split('.')[1].toLowerCase();
                    let type = "";
                    if (ext === "jpg")
                        type = "image/jpeg";
                    else if (ext === "png")
                        type = "image/png";
                    else if (ext === "gif")
                        type = "image/gif";
                    else if (ext === "pdf")
                        type = "application/pdf";
                    let byteCharacters = atob(result.data.LiveRes);

                    let byteNumbers = new Array(byteCharacters.length);
                    for (var i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }

                    let byteArray = new Uint8Array(byteNumbers);

                    let blob = new Blob([byteArray], { "type": type });

                    if (navigator.msSaveBlob) {
                        let filename = Attachment.SourceFileName;
                        navigator.msSaveBlob(blob, filename);
                    } else {
                        let link = document.createElement("a");

                        link.href = URL.createObjectURL(blob);

                        link.setAttribute('visibility', 'hidden');
                        link.download = Attachment.SourceFileName;

                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }

                }
                this.setState({ isLoading: false });
            },
            (e: any) => {
                this.setState({ isLoading: false });
            },
            (value: any) => String(value)
        );
    }
    customRequest = (file: any) => {
        let data = new FormData();
        data.append('file', file);
        let files: any = this.state.Files;
        files.push({ FileData: file.Data.substring(file.Data.indexOf(",") + 1), FileName: file.name, ContentType: file.type });
        this.setState({ Files: files });
    }
    customRemove = (removedFile: any) => {
        let fileToRemove: any = this.state.Files.filter((file: any) => file.Id === removedFile.Id)[0];
        let files = this.state.Files.filter((file: any) => file.Id !== removedFile.Id);
        this.setState({ Files: files });
    }
    TSOnChange = (e: any) => {
        let ActionParams: YoonitRequest<any> = {
            ObjData: {
                TicketID: this.state.TicketID,
                StatusID: +(e.value)
            }
        };
        this.setState({ isLoading: true });
    }
    FillSelectOptions = (SelectOpt: any, value: string, label: string) => {
        let _options: any = [];
        for (var k = 0; k < SelectOpt.length; k++) {
            _options.push({ value: SelectOpt[k][value], label: SelectOpt[k][label] });
        }
        return _options
    };
    fillSelectsWithIcons = (SelectOpt: any, stateName: string, value: string, label: string, icon: string) => {
        let _options: any = [];
        for (var k = 0; k < SelectOpt.length; k++) {
            _options.push({ value: SelectOpt[k][value], label: <div><i className={SelectOpt[k][icon]}></i>&nbsp;{SelectOpt[k][label]}</div>, icon: SelectOpt[k][icon] });
        }
        this.setState({
            [stateName]: _options,
        } as any);
        return _options;
    };
    ScrollToReply = () => {
        $(document).ready(function () {
            $("#ScrollBtn").click(function () {
                $('html, body').animate({
                    scrollTop: $("#replyParagraph").offset().top
                }, 2000);
            });
        });
    }
    openPic = (url: any) => {
        let a = document.createElement('a');
        a.target = '_blank';
        a.href = url;
        a.click();
    }
    ReturnStatus = (status: any) => {
        if (status === "new" || status === "New") {
            return <span className="NewStatus">New</span>;
        }
        if (status === "open" || status === "Opened") {
            return <span className="OpenStatus">Open</span>;
        }
        if (status === "pending" || status === "Pending") {
            return <span className="PendingStatus">Pending</span>;
        }
        if (status === "solved" || status === "Solved") {
            return <span className="SolvedStatus">Solved</span>;
        }
        if (status === "closed" || status === "Closed") {
            return <span className="ClosedStatus">Closed</span>;
        }

        return status;
    }
    render() {
        return (
            <div className="m20">
                <SpinnerComponent loading={this.state.isLoading} position="inline" color="#00ad0f" />
                {this.state.openPreview &&
                    <div className="centerImage">
                        <dialog
                            className="dialog TicketImage"
                            style={{ position: "absolute" }}
                            open={this.state.openPreview}
                            onClick={this.closePreview}
                        >
                            <div>
                                <div className="d-flex">
                                    <div className="mr-auto p-2 mt-3"></div>
                                    <div className="ml-auto floatRight"> <Close className="closeButtonDialog mr-1 cursor-pointer" onClick={this.closePreview} /></div>
                                </div>
                                <img
                                    className="imgDialog"
                                    alt=""
                                    src={this.state.fileSrc}
                                />
                            </div>
                        </dialog>
                    </div>
                }
                <Row>


                    <Col md={12} className="EachRightColumn">
                        <div className="Stickyheader">

                            <Label className="font-20 text-darkBlack d-block mb-3t-bold ml-3 cursor-pointer mt-3" onClick={this.navigateToTickets}> <FontAwesomeIcon icon={faChevronLeft} className="font-20 mr-3" /> {this.state.TicketSubject} </Label>


                            <Col md={12} className="pr-0">
                                <div>
                                    {
                                        //<>
                                        //    <div className="d-block mb-3">
                                        //        <Avatar className="avatar">H</Avatar>
                                        //        <Label className="LabelCreate2 ml-3"> Name here</Label>
                                        //    </div>
                                        //    <Divider />
                                        //</>
                                    }
                                    <div className="mt-3">

                                        <Label className="LabelCreate2 d-block ml35">  <span className="mr-2">{this.ReturnStatus(this.state.Status)}</span>  {this.props.t('CreatedOn')}  {moment(this.state.CreationDateStr || new Date()).format('DD MMM YYYY [,] h:mm A')}</Label>
                                    </div>
                                    <Col md={5} className="noPadding mb-4">
                                        {/*<Col md={3} className="d-inline-flex noPaddingRight">*/}
                                        {/*    <Select*/}
                                        {/*        className="react-select-container LargeSelect BlueBorders Select100w"*/}
                                        {/*        classNamePrefix="react-select cursor-pointer LargeSelect DarkSelect BlueBorders addBorderRadius "*/}
                                        {/*        isSearchable*/}
                                        {/*        placeholder={this.props.t('Status')}*/}
                                        {/*        options={this.state.TSOptions}*/}
                                        {/*        value={this.state.TSSelectedOption}*/}
                                        {/*        onChange={this.TSOnChange}*/}
                                        {/*        isDisabled={false}*/}
                                        {/*    />*/}
                                        {/*</Col>*/}
                                        <Button hidden className=" ButtonsModal ml-2" onClick={this.ScrollToReply} id="ScrollBtn">  <FontAwesomeIcon icon={faReply} className="cursor-pointer mr-2" /> {this.props.t('Reply')} </Button>
                                    </Col>

                                </div>
                            </Col>
                        </div>
                        <Divider />
                        <div className="p50 ml-3">
                            <div className="mt-3 pt-3 mb-3 w100p d-block">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: this.state.TicketBody
                                    }}
                                />
                            </div>
                            <Divider />
                        </div>
                        <div className="mt-2 p-3">
                            {this.state.TicketComments.map((comment: any) =>
                                <Col key={comment.Id} md={12} className={`${this.state.RequesterId === comment.AuthorId ? "backgroundGrey2" : "backgroundGrey2"} p-3 mb-2 borderRadius5`}>
                                    <div className="d-block mb-3">
                                        <div className="d-flex align-items-center">
                                            <div>
                                                <Avatar className={`${this.state.RequesterId === comment.AuthorId ? "avatar2" : "avatar3"} avatar2 mr-2`} >{comment.CreatedByName.charAt(0)}</Avatar>
                                            </div>
                                            <div>
                                                <Label className="font-16 ticketText ml-2 t-bold mr-2"> {comment.CreatedByName}</Label>
                                            </div>
                                            <div className="ml-auto">
                                                <Label className="opacity7 LabelCreate2 d-block "> {moment(comment.CreatedAt || new Date()).format('DD MMM YYYY [,] h:mm A')} </Label>
                                            </div>
                                        </div>

                                        <div className="d-block pl58">
                                            <div ></div>

                                            <Label className=" LabelCreate2 d-block">
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: comment.HtmlBody
                                                    }}
                                                />
                                            </Label>

                                            {comment.Attachments.map((attach: any) =>
                                                <Label className=" LabelCreate2 d-block attachText cursor-pointer" onClick={() => this.openPic(attach.MappedContentUrl)}> {attach.FileName}  </Label>
                                            )}
                                        </div>
                                    </div>
                                </Col>
                            )}
                        </div>
                        <div className="p-3" id="replyParagraph">
                            <ParagraphEditor
                                ref={this.Editor}
                                key={"TicketReply2"}
                                index={1}
                                setContent={this.SetReplyContent}
                                ETContent={this.state.commentField}
                            >
                            </ParagraphEditor>
                        </div>
                        <Col md={12} className="d-inline-flex p-0 p-3">
                            <Uploader
                                ref={this.uploadRef}
                                translate={this.props.t}
                                openPreview={this.PreviewAttachment}
                                customRequest={this.customRequest}
                                customRemove={this.customRemove}
                                onTheRight={true}
                            />
                            <div className="d-inline-flex ml-auto">
                                <div className="ml-auto mt-3 align-items-start d-inline-flex">
                                    <Button className=" ButtonsModal2 mr-2" onClick={this.cancelAddComment}> {this.props.t('Cancel')} </Button>
                                    <Button className=" ButtonsModal ml-2" onClick={this.addComment}>  {this.props.t('Send')}  </Button>
                                </div>
                            </div>
                        </Col>

                    </Col>
                </Row>
            </div>);
    }
}
export default withTranslation()(connect(mapStateToProps, dispatchProps)(EachTicket));
